import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTestBuy = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#111",
		d: "M4 4v16h16v-7h-2v5H6V6h10V4H4z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		d: "m19.7 8.2-1.4-1.4L12 13l-2.8-2.8-1.4 1.4L12 16l7.7-7.7z"
	})]
});
export default SvgTestBuy;
